module.exports = __webpack_public_path__ + "img/BQ-BO.bed11784.svg";